import React from 'react'
import { ChatBackend, ChatService } from '~/stores/chat'
import { Avatar } from '~/ui/app/media'
import { observer } from '~/ui/component'
import { Badge, HBox, SVG, Tappable, VBox } from '~/ui/components'
import { createUseStyles, layout } from '~/ui/styling'

export interface Props {
  service:  ChatService
  onExpand: () => void
}

const ChatMiniPanel = observer('ChatMiniPanel', (props: Props) => {

  const {service, onExpand} = props

  //------
  // Rendering

  const $ = useStyles()

  function render() {
    return (
      <VBox classNames={$.panel} flex>
        <HBox justify='center' align='middle' classNames={$.toggleRow}>
          <Tappable onTap={onExpand} classNames={$.toggleButton}>
            <SVG name='chat-open' size={layout.icon.l} primary />
          </Tappable>
        </HBox>
        <VBox classNames={$.avatarScroll} flex align='center'>
          <VBox classNames={$.avatarList} gap={layout.padding.inline.m}>
            {service.chats.map(renderChatAvatar)}
          </VBox>
        </VBox>
      </VBox>
    )
  }

  function renderChatAvatar(backend: ChatBackend) {
    const {descriptor, unreadCount} = backend

    const goToChat = () => {
      service.switchToChat(descriptor.uri)
      onExpand()
    }

    return (
      <Tappable key={descriptor.uri} classNames={$.avatarWrapper} onTap={goToChat}>
        <Avatar
          source={descriptor.image}
          firstName={descriptor.name}
          size={miniAvatarSize}
        />
        <Badge
          value={unreadCount > 0 ? unreadCount : null}
          classNames={$.badge}
          small
        />
      </Tappable>
    )
  }

  return render()

})

export default ChatMiniPanel

const miniAvatarSize = {
  width:  40,
  height: 40,
}

const badgeOverflow = 6

const useStyles = createUseStyles(theme => ({
  panel: {},

  toggleRow: {
    height:       layout.barHeight.l,
    paddingRight: 5,
  },

  toggleButton: {},

  avatarScroll: {
    overflowY: 'auto',
  },

  avatarList: {
    padding:       badgeOverflow,
    paddingBottom: layout.padding.inline.m,
  },

  avatarWrapper: {
    position: 'relative',
    cursor:   'pointer',
  },

  badge: {
    position: 'absolute',
    top:      -badgeOverflow,
    right:    -badgeOverflow,
  },
}))
